/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { getActiveProfile, getActiveProfileId, getMainProfileId } from '../../../redux/reduxSelectors';
import { selectors as listSelectors } from '../../../../redux/ducks/lists/lists';
import ProfileActions from '../../../redux/ProfileActions';
import { userSelectors } from '../../../../redux/selectors_authorizedApp';

import List, { CardListItem } from '../../../../components/List';

import ColorThemeSwatch from './ColorThemeSwatch';
import Card from '../../../../components/card/Card';
import FlexRow from '../../../../components/FlexRow';
import ContentWrapper from '../../../../components/ContentWrapper';
import Spacer from '../../../../components/Spacer';

function mapStateToProps(state) {
  const profile = getActiveProfile(state);
  const isMainProfile = getActiveProfileId(state) === getMainProfileId(state);

  const colorThemeCollection = listSelectors.getColorThemeCollection(state);
  const selectedColorThemeId = profile.getColorThemeId();

  const regularColorThemeCollection = colorThemeCollection.filter((c) => c.accessible === 0);
  const accessibleColorThemeCollection = colorThemeCollection.filter((c) => c.accessible === 1);
  const selectedColorTheme = colorThemeCollection.filter((c) => c.id === selectedColorThemeId)[0] || {};

  return {
    profile,
    locale: userSelectors.getPreferredLocale(state),

    regularColorThemeCollection,
    accessibleColorThemeCollection,
    selectedColorTheme,
    isMainProfile,

    selectColorTheme: (colorTheme) => {
      profile.setColorThemeId(colorTheme.id);
      ProfileActions.setCurrentColorTheme(colorTheme);
      ProfileActions.api.updateProfile(profile.data, (apiError) => {
        if (apiError) {
          this.setState({
            viewErrorMessage: apiError.messageKey(),
          });
        }
      });
    },
  };
}

interface Props {
  profile: any;
  locale: any;
  regularColorThemeCollection: any[];
  accessibleColorThemeCollection: any[];
  selectedColorTheme: any;
  isMainProfile: boolean;
  selectColorTheme(c): void;
  goToLanguages(): void;
}

const ThemeRow = ({ color, selectedColor, isAccessible = false, onSelect }) => (
  <CardListItem onClick={onSelect}>
    <FlexRow style={{ justifyContent: 'flex-start' }}>
      <ColorThemeSwatch
        isSelected={color.id === selectedColor.id}
        size={48}
        baseColor={color.base_color}
        accentColor={color.accent_color}
        highlightColor={color.highlight_color}
        strokeWidth={2}
      />
      <div className="font-body color-gsDarkest" style={{ marginLeft: 12 }}>
        <div>
          <FormattedMessage id={color.key} />
        </div>
        {isAccessible && <div className="font-footnote font-color-gsMedDark">
          <Spacer size="2" />
          <FormattedMessage id="profile.themeAccessibility.field.label" />
        </div>}
      </div>
    </FlexRow>
  </CardListItem>
);

class ProfileTheme extends React.Component<Props, {}> {
  render() {
    return (
      <ContentWrapper>
        <Card>
          <List>
            {
              this.props.regularColorThemeCollection.map((c) => (
                <ThemeRow
                  key={c.id}
                  color={c}
                  selectedColor={this.props.selectedColorTheme}
                  onSelect={() => { this.props.selectColorTheme(c); }}
                />
              ))
            }

            {
              this.props.accessibleColorThemeCollection.map((c) => (
                <ThemeRow
                  key={c.id}
                  color={c}
                  selectedColor={this.props.selectedColorTheme}
                  isAccessible
                  onSelect={() => { this.props.selectColorTheme(c); }}
                />
              ))
            }
          </List>
        </Card>
      </ContentWrapper>
    );
  }
}

export default connect(mapStateToProps)(ProfileTheme);
